import * as React from 'react';
import clsx from 'clsx';
import SimpleBar, { Props as SimpleBarProps } from 'simplebar-react';
import { isMobile } from 'react-device-detect';
import './style.scss';
// import 'simplebar-react/dist/simplebar.min.css';

export interface IAutoScrollbarsProps {
    className?: string;
    style?: React.CSSProperties;
    simplebarProps?: Omit<SimpleBarProps, 'ref' | 'children'>;
    scrollDivProps?: Omit<React.HTMLAttributes<HTMLDivElement>, 'ref' | 'children'>;
}

/**
 * Видимо, типы к typescript описаны неправильно у этой библиотеки. Методы, обозначенные здесь,
 * на самом деле есть, но typescript про них ничего не знает.
 */
type PatchedSimpleBar = SimpleBar & {
    getScrollElement: () => HTMLElement;
};

export class AutoScrollbars extends React.Component<IAutoScrollbarsProps> {
    public simplebarRef = React.createRef<PatchedSimpleBar>();
    public divRef: HTMLDivElement = null;

    public getScrollElement() {
        if (isMobile) {
            return this.divRef;
        } else {
            return this.simplebarRef.current.getScrollElement();
        }
    }

    render() {
        let {
            style,
            className,
            simplebarProps,
            scrollDivProps,
            children
        } = this.props;

        if (isMobile) {
            return (
                <div
                    className={className}
                    style={{
                        ...style,
                        height: '100%',
                        width: '100%',
                        overflowY: 'auto'
                    }}
                    ref={el => { this.divRef = el; }}
                    {...scrollDivProps}
                >
                    {children}
                </div>
            );
        } else {
            return (
                <SimpleBar
                    style={{
                        height: '100%',
                        width: '100%',
                        ...style
                    }}
                    className={clsx('custom-app-scrollbar', className)}
                    ref={this.simplebarRef}
                    {...simplebarProps}
                >
                    { children }
                </SimpleBar>
            );
        }
    }
}
